import { createFileRoute } from '@tanstack/react-router';

import { ApprovalsHistoryPage } from '@/features/approvals/approvals-history.page';

export const Route = createFileRoute('/__authenticated/approvals/history')({
	component: ApprovalsHistoryPage,
});
